module.exports = __webpack_public_path__ + "img/logo.dc87e743.png";